export default "__VITE_ASSET__z3cop_tI__"